import { all, takeLatest } from "redux-saga/effects";

// import "regenerator-runtime/runtime";
import { ProjectApi } from "Services/ApiServices";
import { ProjectTypes } from "Redux/ProjectRedux";
import {
  addResourcesSaga,
  createProjectSaga,
  deleteProjectSaga,
  updateFeedSaga,
  updateDetailSaga,
  exploreProjectsSaga,
  getCommentsSaga,
  getJoinProjectsSaga,
  getProjectImagesSaga,
  getResourcesSaga,
  getUserProjectsSaga,
  joinProjectSaga,
  postCommentSaga,
  projectDetailSaga,
  projectLeaderSaga,
  projectMembersSaga,
  projectResourcesSaga,
  updateProjectDetailsSaga,
  updateProjectIconSaga,
  updateProjectAvatarSaga, 
  createProjectUpdateSaga,
  getProjectUpdatesSaga,
  deleteProjectUpdateSaga,
  addProjectImageSaga,
  deleteProjectImageSaga,
  saveProjectSaga,
  submitRatingSaga,
} from "Sagas/ProjectSagas/workers";

/* ------------- API ------------- */

// We create our API
const api = ProjectApi.create();

/* ------------- Connect Types To Sagas ------------- */

export default function* projectRoot() {
  yield all([
    takeLatest(
      ProjectTypes.UPDATE_FEED_REQUEST,
      updateFeedSaga,
      api
    ),
    takeLatest(
      ProjectTypes.UPDATE_DETAIL_REQUEST,
      updateDetailSaga,
      api
    ),
    takeLatest(
      ProjectTypes.EXPLORE_PROJECTS_REQUEST,
      exploreProjectsSaga,
      api
    ),
    takeLatest(
      ProjectTypes.PROJECT_DETAIL_REQUEST,
      projectDetailSaga,
      api
    ),
    takeLatest(
      ProjectTypes.PROJECT_LEADER_REQUEST,
      projectLeaderSaga,
      api
    ),
    takeLatest(
      ProjectTypes.PROJECT_RESOURCES_REQUEST,
      projectResourcesSaga,
      api
    ),
    takeLatest(
      ProjectTypes.PROJECT_MEMBERS_REQUEST,
      projectMembersSaga,
      api
    ),
    takeLatest(ProjectTypes.JOIN_PROJECT_REQUEST, joinProjectSaga, api),
    takeLatest(
      ProjectTypes.GET_JOIN_PROJECTS_REQUEST,
      getJoinProjectsSaga,
      api
    ),
    takeLatest(
      ProjectTypes.GET_USER_PROJECTS_REQUEST,
      getUserProjectsSaga,
      api
    ),
    takeLatest(
      ProjectTypes.CREATE_PROJECT_REQUEST,
      createProjectSaga,
      api
    ),
    takeLatest(
      ProjectTypes.GET_RESOURCES_REQUEST,
      getResourcesSaga,
      api
    ),
    takeLatest(
      ProjectTypes.ADD_RESOURCES_REQUEST,
      addResourcesSaga,
      api
    ),
    takeLatest(
      ProjectTypes.DELETE_PROJECT_REQUEST,
      deleteProjectSaga,
      api
    ),
    takeLatest(
      ProjectTypes.UPDATE_PROJECT_DETAILS_REQUEST,
      updateProjectDetailsSaga,
      api
    ),
    takeLatest(ProjectTypes.POST_COMMENT_REQUEST, postCommentSaga, api),
    takeLatest(ProjectTypes.GET_COMMENTS_REQUEST, getCommentsSaga, api),
    takeLatest(
      ProjectTypes.GET_PROJECT_IMAGES_REQUEST,
      getProjectImagesSaga,
      api
    ),
    takeLatest(
      ProjectTypes.UPDATE_PROJECT_ICON_REQUEST,
      updateProjectIconSaga,
      api
    ),
    takeLatest(
      ProjectTypes.UPDATE_PROJECT_AVATAR_REQUEST,
      updateProjectAvatarSaga,
      api
    ),
    takeLatest(
      ProjectTypes.CREATE_PROJECT_UPDATE_REQUEST,
      createProjectUpdateSaga,
      api
    ),
    takeLatest(
      ProjectTypes.GET_PROJECT_UPDATES_REQUEST,
      getProjectUpdatesSaga,
      api
    ),
    takeLatest(
      ProjectTypes.DELETE_PROJECT_UPDATE_REQUEST,
      deleteProjectUpdateSaga,
      api
    ),
    takeLatest(
      ProjectTypes.ADD_PROJECT_IMAGE_REQUEST,
      addProjectImageSaga,
      api,
    ),
    takeLatest(
      ProjectTypes.DELETE_PROJECT_IMAGE_REQUEST,
      deleteProjectImageSaga,
      api,
    ),
    takeLatest(
      ProjectTypes.SAVE_PROJECT_REQUEST,
      saveProjectSaga,
      api,
    ),
    takeLatest(
      ProjectTypes.SUBMIT_RATING_REQUEST,
      submitRatingSaga,
      api,
    )
  ]);
}
